/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as interactions from "../interactions/index.js";
import { GoogleGenAiError } from "./google-gen-ai-error.js";

/**
 * Error deleting interaction
 */
export type DeleteInteractionServerErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error deleting interaction
 */
export class DeleteInteractionServerError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: DeleteInteractionServerErrorData;

  constructor(
    err: DeleteInteractionServerErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "DeleteInteractionServerError";
  }
}

/**
 * Error deleting interaction
 */
export type DeleteInteractionClientErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error deleting interaction
 */
export class DeleteInteractionClientError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: DeleteInteractionClientErrorData;

  constructor(
    err: DeleteInteractionClientErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "DeleteInteractionClientError";
  }
}
